import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '@environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatCarouselModule } from '@ngbmodule/material-carousel';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { NgChartjsModule } from 'ng-chartjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { AdminModule } from './components/admin/admin.module';
import { ChooseAppliComponent } from './components/choose-appli/choose-appli.component';
import { ContactComponent } from './components/contact/contact.component';
import { OpenDialogEditUserComponent } from './components/dialog/open-dialog-edit-user/open-dialog-edit-user.component';
import { OpenDialogIsActiveComponent } from './components/dialog/open-dialog-is-active/open-dialog-is-active.component';
import { OpendialogSendMailPasswordComponent } from './components/dialog/opendialog-send-mail-password/opendialog-send-mail-password.component';
import { ErrorComponent } from './components/error/error.component';
import { MainModule } from './components/main/main.module';
import { SmartparkingModule } from './components/smartparking/smartparking.module';
import { SmartwasteModule } from './components/smartwaste/smartwaste.module';
import { ValidationAnimationComponent } from './components/validation-animation/validation-animation.component';
import { appInitializerProviders } from './shared/apiInitializerProviders';
import { ApiMissingTranslationHandler } from './shared/apiMissingTranslationHandler';
import { ApiTranslateLoader } from './shared/apiTranslationLoader';
import { httpInterceptorProviders } from './shared/http-interceptors';
import { SharedModule } from './shared/shared.module';
import { WikiModule } from './components/wiki/wiki.module';
import { HelpComponent } from './components/help/help.component';



registerLocaleData(localeFr, 'fr');

export function tokenGetterFactory(): string {
  return localStorage.getItem(environment.tokenKey);
}

export function TranslateLoaderFactory(http: HttpClient): ApiTranslateLoader {
  return new ApiTranslateLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ChooseAppliComponent,
    ErrorComponent,
    OpendialogSendMailPasswordComponent,
    ValidationAnimationComponent,
    OpenDialogIsActiveComponent,
    OpenDialogEditUserComponent,
    ContactComponent,
    HelpComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    SharedModule,
    SmartparkingModule,
    SmartwasteModule,
    WikiModule,
    AdminModule,
    IvyCarouselModule,
    SharedModule,
    // MaterialModule,
    MainModule,
    FontAwesomeModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgChartjsModule,
    MatCarouselModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyC7Wt3VDl1byLs_VXiNhxq3HKcOwWofB8Y'
    }),
    AgmJsMarkerClustererModule,

    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetterFactory,
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: [environment.identityApiUrl + 'connect/token']
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: ApiMissingTranslationHandler
      }
    })



  ],
  providers: [
    appInitializerProviders,
    httpInterceptorProviders,
    { provide: LOCALE_ID, useValue: 'fr' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


